import { Route, Routes } from "react-router-dom";
import { EvidenceRegister } from "./list";
import { ConciliationErrorBoundary } from "@/components/conciliation-error-boundary";

export default function RegisterEvidenceRoute() {
  return (
    <ConciliationErrorBoundary screen="evidence-register">
      <Routes>
        <Route path="/" element={<EvidenceRegister />} />
      </Routes>
    </ConciliationErrorBoundary>
  );
}
